/** TODO: Delete when migrating apply */
import React from 'react';
import { Box } from '@mui/material';
import { FormProvider } from 'react-hook-form';

const Form = ({
  form, handleSubmit, children, ...props
}) => (
  <Box
    component="form"
    onSubmit={handleSubmit}
    {...props}
  >
    <FormProvider {...form}>
      {children}
    </FormProvider>
  </Box>
);

export default Form;
